import { generateVariantData } from '../../../../experiments/utils';
import PlanSelector from './PlanSelector';
import PlanSelectorRedesign from './PlanSelectorRedesign';
import PlanSelectorV3 from './V3';
import PlanSelectorV4 from './V4';

const planDisplayData = {
  paymentModuleVariant1: {
    title: 'Ready to Sign Up?',
    component: PlanSelector,
    includedInPlans: {
      title: 'All Plans Include:',
      listIcon: `${process.env.REACT_APP_CLOUDFRONT_URL}/flagship/checkmark_light_blue.svg`,
      values: [
        '100s of educational puzzles',
        'New skills EVERY WEEK',
        'Access for up to 3 children',
      ],
    },
    // legacy way of generating plan props, new ones are created through planDisplayData.js
    subscriptionPlansProps: {
      monthly: {},
      annual: {
        showGlitch: true,
        flagText: 'Save 33%',
      },
    },
  },
  paymentModuleVariant2: {
    title: 'Ready to Sign Up?',
    component: PlanSelector,
    includedInPlans: {
      title: 'All Plans Include:',
      listIcon: `${process.env.REACT_APP_CLOUDFRONT_URL}/global/icons/checkmark-white.svg`,
      values: [
        '100s of educational puzzles',
        'New skills EVERY WEEK',
        'Access for up to 3 children',
      ],
    },
    // legacy way of generating plan props, new ones are created through planDisplayData.js
    subscriptionPlansProps: {
      monthly: {},
      annual: {
        showGlitch: true,
        flagText: 'Save 33%',
      },
    },
  },
  homepageRedesign: {
    title: 'Plan options',
    component: PlanSelectorRedesign,
    valueProps: [
      {
        text: 'Unlimited access to codeSpark app',
        key: 'access',
      },
      {
        text: 'Fun printable worksheets',
        key: 'worksheets',
      },
      {
        text: '10 pre-recorded lessons',
        subnote: 'Taught by expert teachers',
        key: 'prerecordedLessons',
      },
      {
        text: 'Parent Portal',
        key: 'parentPortal',
      },
      {
        text: 'Progress reports',
        key: 'progressReports',
      },
      {
        text: 'Up to 5 child profiles',
        key: 'multipleChildProfiles',
      },
    ],
  },
  premiumOndemandClasses: {
    title: 'All Plans Include:',
    component: PlanSelectorV3,
    valueProps: [
      '12 pre-recorded video lessons',
      'Digital workbook',
      'Parent portal',
      'Unlimited access to codeSpark app',
      'Up to 3 child app profiles',
      'Progress reports',
    ],
  },
  premiumVsStandardDesign: {
    title: 'Plan options',
    component: PlanSelectorV4,
    valueProps: [
      {
        text: 'Unlimited access to codeSpark app',
        key: 'access',
      },
      {
        text: 'Digital workbook',
        key: 'workbook',
      },
      {
        text: '12 self-paced lessons',
        key: 'selfPacedLessons',
      },
      {
        text: 'Parent portal',
        key: 'parentPortal',
      },
      {
        text: 'Progress reports',
        key: 'progressReports',
      },
      {
        text: 'Up to 3 child app profiles',
        key: 'multipleChildProfiles',
      },
    ],
  },
  premiumOndemandClassesTrials: {
    title: 'All Plans Include:',
    component: PlanSelectorV3,
    valueProps: [
      'New Skills EVERY Week',
      '100s of educational puzzles',
      'Kids can create their own games',
      '12 self-paced lessons from a teacher',
      'Progress reports for parents',
      'Access for up to 3 children',
    ],
  },
};

const DEFAULT_KEY = 'paymentModuleVariant1';
export const getVariantCopies = generateVariantData(planDisplayData, DEFAULT_KEY);

const MOBILE_KEY = 'mobile';
const DESKTOP_KEY = 'desktop';

const DEFAULT_ORDER_DESKTOP = {
  monthly: 0,
  annual: 1,
};

const DEFAULT_ORDER_MOBILE = {
  monthly: 1,
  annual: 0,
};

const experimentToOrderMapping = {
  paymentModuleVariant1: {
    [DESKTOP_KEY]: DEFAULT_ORDER_DESKTOP,
    [MOBILE_KEY]: DEFAULT_ORDER_MOBILE,
  },
  paymentModuleVariant2: {
    [DESKTOP_KEY]: DEFAULT_ORDER_DESKTOP,
    [MOBILE_KEY]: DEFAULT_ORDER_MOBILE,
  },
  homepageRedesign: {
    [DESKTOP_KEY]: {
      Annual_7DayTrial_7999_restricted: 0,
      minerva_annual_ondemand_120_7trial: 1,
    },
    [MOBILE_KEY]: {
      Annual_7DayTrial_7999_restricted: 1,
      minerva_annual_ondemand_120_7trial: 0,
    },
  },
  premiumOndemandClasses: {
    [DESKTOP_KEY]: {
      minerva_annual_ondemand_100: 0,
      minerva_quarterly_ondemand_41: 1,
    },
    [MOBILE_KEY]: {
      minerva_annual_ondemand_100: 0,
      minerva_quarterly_ondemand_41: 1,
    },
  },
  premiumVsStandardDesign: {
    [DESKTOP_KEY]: {
      minerva_annual_ondemand_100: 0,
      quarterly_7trial_41_restricted: 1,
      minerva_24month_ondemand_100: 0,
      Annual_7DayTrial_6999_restricted: 1,
    },
    [MOBILE_KEY]: {
      minerva_annual_ondemand_100: 0,
      quarterly_7trial_41_restricted: 1,
      minerva_24month_ondemand_100: 0,
      Annual_7DayTrial_6999_restricted: 1,
    },
  },
  premiumOndemandClassesTrials: {
    [DESKTOP_KEY]: {
      minerva_annual_ondemand_90_7trial: 0,
      minerva_annual_ondemand_90_14trial: 0,
      minerva_monthly_ondemand_15_7trial: 1,
    },
    [MOBILE_KEY]: {
      minerva_annual_ondemand_90_7trial: 0,
      minerva_annual_ondemand_90_14trial: 0,
      minerva_monthly_ondemand_15_7trial: 1,
    },
  }
};

export const sortPlans = (plans, order) => {
  return plans.slice().sort((a, b) => order[a.planDataKey] - order[b.planDataKey]);
};
export const getPlanOrder = ({ isMobile, enabledExperiment }) => {
  const viewport = isMobile ? MOBILE_KEY : DESKTOP_KEY;

  if (enabledExperiment && experimentToOrderMapping[enabledExperiment]) {
    return experimentToOrderMapping[enabledExperiment][viewport];
  }

  return isMobile ? DEFAULT_ORDER_MOBILE : DEFAULT_ORDER_DESKTOP;
};



// WEBPACK FOOTER //
// ./src/containers/Home/sections/PaymentModule/paymentModuleData.js